import { useEffect, useState } from 'react';

export const DEFAULT_BRANDING = {
    productName: 'PayrollNoot',
    primaryColor: '#E7730A',
    darkColor: '#CC5500',
    logoUrl: null,
    loginLogoUrl: null,
    faviconUrl: null,
};

const readBranding = () => {
    try {
        const stored = JSON.parse(localStorage.getItem('branding') || 'null');
        if (stored && typeof stored === 'object') {
            return { ...DEFAULT_BRANDING, ...stored };
        }
    } catch { /* ignore parse errors */ }
    return { ...DEFAULT_BRANDING };
};

const useBranding = () => {
    const [branding, setBranding] = useState(readBranding);

    useEffect(() => {
        const refresh = () => setBranding(readBranding());
        window.addEventListener('branding-updated', refresh);
        window.addEventListener('storage', refresh);
        return () => {
            window.removeEventListener('branding-updated', refresh);
            window.removeEventListener('storage', refresh);
        };
    }, []);

    return branding;
};

export default useBranding;
